import React from 'react';
import styled, {css} from 'styled-components';
import { constants } from '../../../constants';

export const FormGroup = styled.div`
    display: flex; 
    justify-content: space-between;
    align-items: flex-start; 
    margin-bottom: 5px;
    flex-direction: row;
    flex-wrap: wrap;

    ${props => props.stack && css`
        flex-direction: column;
        display: flex;
        align-items: flex-start;
        div {
            display: flex;
            
            svg {
                align-self: center;
            }
        }
        
    `}
`;


// WEBPACK FOOTER //
// ./src/js/components/Form/StyledComponents/FormGroup.jsx